
export class CustomerOrganizationName {
    public customerNameId: number;
    public customerNumberID: number;
    public customerNameTypeId: number;
    public organizationName: string;

    public isVerified: boolean;
    public inactivate: boolean;
    public updatedBy: string;
    public updatedDate: any;

    public organizationNameType: string;
}
